"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatePolicyDocketDto = exports.ServiceLevelAgreementDto = exports.PlacementSlipDetailsDto = exports.PolicyDocketDocumentDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class PolicyDocketDocumentDto {
}
exports.PolicyDocketDocumentDto = PolicyDocketDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document Type ID",
        example: 237,
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", Number)
], PolicyDocketDocumentDto.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID",
        example: 25,
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", Number)
], PolicyDocketDocumentDto.prototype, "documentId", void 0);
class PlacementSlipDetailsDto {
}
exports.PlacementSlipDetailsDto = PlacementSlipDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "2025-10-15",
        description: "Date of Issuance",
    }),
    (0, class_validator_1.IsString)({ message: "Date of Issuance must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    (0, class_validator_1.Matches)(/^\d{4}-\d{2}-\d{2}$/, {
        message: "Date of Issuance must be in the format YYYY-MM-DD.",
    }),
    tslib_1.__metadata("design:type", String)
], PlacementSlipDetailsDto.prototype, "issuanceDate", void 0);
class ServiceLevelAgreementDto {
}
exports.ServiceLevelAgreementDto = ServiceLevelAgreementDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 101,
        description: "Held cover note",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], ServiceLevelAgreementDto.prototype, "heldCoverNote", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 102,
        description: "Policy document",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], ServiceLevelAgreementDto.prototype, "policyDocument", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 103,
        description: "Policy docket reference",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], ServiceLevelAgreementDto.prototype, "policyDocket", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 104,
        description: "Endorsement reference",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], ServiceLevelAgreementDto.prototype, "endorsement", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 105,
        description: "Health claims reference",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], ServiceLevelAgreementDto.prototype, "healthClaims", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 106,
        description: "Non-health claims reference",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], ServiceLevelAgreementDto.prototype, "nonHealthClaims", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 107,
        description: "MIR reference",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], ServiceLevelAgreementDto.prototype, "mir", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 108,
        description: "Monthly meeting reference",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], ServiceLevelAgreementDto.prototype, "monthlyMeeting", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 109,
        description: "Quarterly meeting reference",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], ServiceLevelAgreementDto.prototype, "quarterlyMeeting", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Renewal Notice",
        description: "Renewal Notice",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], ServiceLevelAgreementDto.prototype, "renewalNotice", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Data Collection",
        description: "Data Collection",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], ServiceLevelAgreementDto.prototype, "dataCollection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Additional remarks about the policy docket",
        description: "Remarks",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ServiceLevelAgreementDto.prototype, "remarks", void 0);
class CreatePolicyDocketDto {
}
exports.CreatePolicyDocketDto = CreatePolicyDocketDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 789,
        description: "Opportunity Activity ID",
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", Number)
], CreatePolicyDocketDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "Status ID",
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", Number)
], CreatePolicyDocketDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PlacementSlipDetailsDto),
    tslib_1.__metadata("design:type", PlacementSlipDetailsDto)
], CreatePolicyDocketDto.prototype, "placementSlipDetailsSection", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => ServiceLevelAgreementDto),
    tslib_1.__metadata("design:type", ServiceLevelAgreementDto)
], CreatePolicyDocketDto.prototype, "serviceLevelAgreementSection", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Documents must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => PolicyDocketDocumentDto),
    tslib_1.__metadata("design:type", Array)
], CreatePolicyDocketDto.prototype, "documents", void 0);
